import { c as _c } from "react/compiler-runtime";
import { Spinner } from "@/components/dotLoader/DotLoader";
import type { WaveNotificationSettingsState } from "./useWaveNotificationSettings";
interface WaveNotificationRetryButtonProps {
  readonly settings: WaveNotificationSettingsState;
}
export default function WaveNotificationRetryButton(t0) {
  const $ = _c(6);
  const {
    settings
  } = t0;
  let t1;
  if ($[0] !== settings.preferencesFetching) {
    t1 = settings.preferencesFetching ? <Spinner dimension={12} /> : <span>Retry</span>;
    $[0] = settings.preferencesFetching;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== settings.onRetryClick || $[3] !== settings.preferencesFetching || $[4] !== t1) {
    t2 = <div className="tw-w-full"><button type="button" disabled={settings.preferencesFetching} onClick={settings.onRetryClick} className="tw-flex tw-h-10 tw-w-full tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-transparent tw-px-3 tw-text-xs tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out disabled:tw-cursor-not-allowed disabled:tw-text-iron-500 desktop-hover:hover:tw-text-iron-300 lg:tw-h-9" aria-label="Retry notification settings">{t1}</button></div>;
    $[2] = settings.onRetryClick;
    $[3] = settings.preferencesFetching;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}